'use client';

import React from 'react';

import ModularSofaBundleContext from './ModularSofaBundleContext';

// Provides server-fetched modular sofa bundle data to the modular PDP subtree
// so the server-side useSuspenseQuery in useModularPDPState is bypassed.
// `value` is the full fetchFromAlexandria() result — same shape as Apollo `data`.
const ModularSofaBundleProvider = ({ value = null, children }) => (
  <ModularSofaBundleContext.Provider value={value}>
    {children}
  </ModularSofaBundleContext.Provider>
);

export default ModularSofaBundleProvider;
